import gql from 'graphql-tag';

export default gql`
  query GetAllApplications($status: ApplicationStatus, $searchTerm: String, $filterTerm: [ApplicationType!]) {
    applications(
      orderBy: updatedAt_DESC
      where: {
        status: $status
        type_in: $filterTerm
        OR: [
          { rejectReason_contains: $searchTerm }
          {
            stakeholder: {
              OR: [
                { firstName_contains: $searchTerm }
                { lastName_contains: $searchTerm }
                { email_contains: $searchTerm }
                { residentialAddress_contains: $searchTerm }
              ]
            }
          }
          {
            property: {
              OR: [
                { address_contains: $searchTerm }
                { salesAgent_contains: $searchTerm }
                { suburb_contains: $searchTerm }
              ]
            }
          }
        ]
      }
    ) {
      id
      createdAt
      updatedAt
      fields
      status
      type
      stakeholder {
        id
        firstName
        lastName
      }
      property {
        address
        id
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/GetAllApplications.ts